import LogoUpload from './LogoUpload';

export default LogoUpload;
